import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Bar } from "react-chartjs-2";

import { getLocalisedNumber } from "../../../Library/helpers";
import { AXIS_LABEL_STYLE, defaultOptions, defaultPlugins, defaultRootPlugins } from "./config";

const BarChart = ({ title, data, parser, options = {}, barThickness = 40, axisStyles = { x: {}, y: {}}, tooltipFormatter, fixLabelWidth }) => {
  const parsing = { parsing: { xAxisKey: parser.x, yAxisKey: parser.y } };

  const formattedData = useMemo(() => {
    const dataset = {
      data: [],
      backgroundColor: [],
      hoverBackgroundColor: [],
      barThickness: barThickness,
      borderRadius: 4,
    };

    data.forEach((d) => {
      dataset.data.push(d);
      dataset.backgroundColor.push(d.color);
      dataset.hoverBackgroundColor.push(d.color);
    })

    return {
      datasets: [ dataset ],
    };
  }, [ data ]);

  const yTickCallback = (value) => {
    if (value === 0) return "";
    else if (parser.yUnit) return (getLocalisedNumber(value) + " " + parser.yUnit);
    else return value;
  };

  return (
    <Bar
      data={formattedData}
      options={{
        ...defaultOptions,
        ...parsing,
        ...options,

        scales: {
          x: {
            title: { text: parser.xLabel, display: !!parser.xLabel, ...AXIS_LABEL_STYLE, ...((axisStyles || {}).x || {}).title },
            grid: { display: false },
            ticks: { maxRotation: 0, minRotation: 0, ...((axisStyles || {}).x || {}).ticks },
          },
          y: {
            title: { text: parser.yLabel, display: !!parser.yLabel, ...AXIS_LABEL_STYLE, ...((axisStyles || {}).y || {}).title },
            grid: { color: "#3C414E", tickLength: 0 },
            ticks: { count: 5, callback: yTickCallback },
            border: { display: false },
            afterFit: (scale) => {
              if (fixLabelWidth) scale.width = 80;
            }
          },
        },

        plugins: {
          legend: defaultPlugins.legend,
          tooltip: { ...defaultPlugins.tooltip, mode: "point", formatter: tooltipFormatter },
          title,
        },
      }}
      plugins={defaultRootPlugins}
    />
  );
}

BarChart.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array,
  parser: PropTypes.shape({
    x: PropTypes.string,
    y: PropTypes.string,
    xLabel: PropTypes.string,
    yLabel: PropTypes.string,
  }),
  options: PropTypes.object,
};

export default BarChart;
